exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pswp__button--share,.pswp__share-tooltip{visibility:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/rcw-carousel/lib/assets/carousel.css
// module id = 1694
// module chunks = 0